import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { commons } from '../../hook/common'
import history from '../../route/history'
import { connect } from 'react-redux'
import * as Common from '../../assets/js/common.js'
import onestop_img1 from '../../assets/images/main/onestop_img1.jpg'
import onestop_img2 from '../../assets/images/main/onestop_img2.jpg'
import onestop_img3 from '../../assets/images/main/onestop_img3.jpg'
import NoticePopup01 from "./popup/NoticePopup01.jsx"
import axios from 'axios'
import QrScanModal from './QrScanModal.jsx'
import { uriConstants } from '../../store/constants';

import {
  alertActions,
  userinfoActions,
  authActions,
  noticeActions,
  manageActions,
  // inboxActions,
  sentActions,
  certboxActions,
  chempCertboxActions,
  chempSendboxActions,
} from '../../store/actions'
import moment from 'moment'
import { isMobile } from 'react-device-detect'

// owl-carousel import
import $ from 'jquery'
import jQuery from 'jquery'
import { memberAppActions } from '../../store/actions/main/memberApp.actions'
window.jQuery = jQuery
require('owl.carousel') // dynamically require owl

const Index = (props) => {
  const [countInfo, setCountInfo] = useState({
    countALL: 0,
  })
  const { auth } = props
  const [userInfo, setUserInfo] = useState({})
  useEffect(() => {
    props.notiLoad()
    // 모바일로 접속했을 경우에만 실행
    if (Common.getDeviceType() === 'MobileApp') {
      window.addEventListener('message', handleDeviceId, false)
      //  window.M.pop.instance(auth?.isLoggedIn)
      if (window.M.info.device('uuid') && auth?.isLoggedIn) {
        // console.log('uuid', window.M.info.device('uuid'))
        props.insertDeviceId(window.M.info.device('uuid'))
      }
      if (!auth?.isLoggedIn) {
        //   window.M.pop.instance(window.M.data.storage('memberId'));
        //   window.M.pop.instance(window.M.data.storage('appAtmcLgnYn'));
        
        // 로컬에서 모바일모드로 보면 에러가 발생해서 만든 예외처리이다.
        //  try {
        //   props.memberAppInsert(window.M.info.device("uuid"), "null" , "null")
        //  } catch(e) {
        //   if(e.name === 'RangeError'){

        //   }else{
        //     throw(e)
        //   }
        //  }
      }
      // 모바일 로그인 && 푸시 동의면 값을 최신화한다.(푸시토큰 값이 변할수 있으므로 로그인할때마다 최신화하는 것이 맞다.)
      let logTest ={}
      logTest.url = 'index.jsx 67 parameter check'
      logTest.user = auth?.user?.payload
      logTest.isTrue = auth?.user?.payload?.almPushYn
      axios.post(uriConstants.API_URI+'/portal/blockchain/logTest',logTest,{headers:{},})
      if(auth?.user?.payload?.almPushYn =='Y'){
        logTest = {}
        logTest.url = 'index.jsx 72 conditional check'
        axios.post(uriConstants.API_URI+'/portal/blockchain/logTest',logTest,{headers:{},})
        window.M.plugin('push').remote.registerServiceAndUser({
          cuid: auth?.user?.payload?.memberId,
          name: auth?.user?.payload?.memberName,
          callback: function( status ) {
              console.log('status : ' + JSON.stringify(status));
              var info = window.M.plugin('push').info();
        
              if (status.status == 'SUCCESS') {
                  console.log('[' + info.CLIENT_UID + '/' + info.CLIENT_NAME + ']의 서비스/유저 등록을 성공 하였습니다.');
              } else {
                  console.log('[' + info.CLIENT_UID + '/' + info.CLIENT_NAME + ']의 서비스/유저 등록을 실패 하였습니다.');
              }
              logTest = {}
              logTest.url = 'index.jsx 88 push id enroll result'
              logTest.status = status
              logTest.pushInfo = info
              axios.post(uriConstants.API_URI+'/portal/blockchain/logTest',logTest,{headers:{},})
          }
        });
      }
    }

    if (!commons.isMobile()) {
      history.replace('/')
      return
    }
  }, [])

  // 해제안하면 윈도우에 계속 남아서 과부하 발생
  useEffect(
    () => () => {
      if (isMobile) {
        window.removeEventListener('message', handleDeviceId, false)
      }
    },
    [],
  )

  useEffect(() => {
    if (props.appAccessResult) {
      console.log('appAccessResult', props.appAccessResult)
    }
  }, [props.appAccessResult])
  let sendSearch = { searchWord: 'main' };
  useEffect(() => {
    if (auth?.isLoggedIn) {
      // props.load()
      // 사업자 정보 변경 초기 조회 roleId: 1(사업자/단체 관리자), 2(사업자/단체 사용자), 3(개인)
      props.auth?.user?.payload?.roleDto?.roleId === 1 && props.getGroupInfo()

      // 수신함 리스트 조회
      props.readInboxList(sendSearch)
      // 송신함 리스트 조회
      props.readSentList()

      // Chemp 관리자 로그인 시 조회되는 문서개수를 위한 리스트 조회
      props.readCertboxList(sendSearch)
      props.readSendboxList(sendSearch)
    }

    var owl1 = $('.owl-visual')
    owl1.owlCarousel({
      items: 1,
      loop: true,
      nav: false,
      dots: false,
      mouseDrag: false,
      animateOut: 'fadeOut',
      animateIn: 'fadeIn',
      autoplay: true,
      autoplayTimeout: 5000,
      autoplaySpeed: 1000,
      autoplayHoverPause: true,
      smartSpeed: 1000,
      onInitialized: visualCounter,
      onChanged: visualCounter,
    })
    $('.visual-slider .btn-next').click(function () {
      owl1.trigger('next.owl.carousel')
    })
    $('.visual-slider .btn-prev').click(function () {
      owl1.trigger('prev.owl.carousel')
    })
    $('.visual-slider .btn-pause').click(function () {
      owl1.trigger('stop.owl.autoplay')
      $(this).hide().next('.btn-play').show().focus()
    })
    $('.visual-slider .btn-play').click(function () {
      owl1.trigger('play.owl.autoplay')
      $(this).hide().prev('.btn-pause').show().focus()
    })
    var owl2 = $('.owl-service')
    owl2.owlCarousel({
      loop: true,
      nav: false,
      dots: false,
      center: true,
      smartSpeed: 1000,
      onInitialized: serviceCounter,
      onChanged: serviceCounter,
      responsive: {
        0: {
          items: 1,
          margin: 10,
          autoWidth: false,
          stagePadding: 20,
        },
        768: {
          items: 1,
          margin: 20,
          autoWidth: false,
          stagePadding: 50,
        },
        1025: {
          items: 1,
          margin: 110,
          autoWidth: true,
        },
      },
    })
    $('.service-slider .btn-next').click(function () {
      owl2.trigger('next.owl.carousel')
    })
    $('.service-slider .btn-prev').click(function () {
      owl2.trigger('prev.owl.carousel')
    })
    var owl3 = $('.owl-notice')
    owl3.owlCarousel({
      nav: false,
      dots: false,
      smartSpeed: 1000,
      margin: 20,
      responsive: {
        0: {
          items: 1,
          loop: true,
          margin: 15,
          stagePadding: 50,
        },
        768: {
          items: 3,
        },
        1024: {
          items: 4,
        },
      },
    })
    var owl4 = $('.owl-banner')
    owl4.owlCarousel({
      nav: false,
      dots: false,
      smartSpeed: 1000,
      margin: 40,
      responsive: {
        0: {
          items: 2.5,
          loop: true,
          margin: 20,
        },
        480: {
          items: 4.6,
          loop: true,
          margin: 20,
        },
        768: {
          items: 5.6,
          loop: true,
          margin: 20,
        },
        1024: {
          items: 6,
        },
      },
    })

    function visualCounter(event) {
      if (!event.namespace) {
        return
      }
      var slides = event.relatedTarget
      $('.visual-slider .pager').text(slides.relative(slides.current()) + 1 + ' / ' + slides.items().length)
    }
    function serviceCounter(event) {
      if (!event.namespace) {
        return
      }
      var slides = event.relatedTarget
      $('.service-slider .pager').text(slides.relative(slides.current()) + 1 + ' / ' + slides.items().length)
    }
  }, [window.callback])
  useEffect(() => {
    // 응답이 도착하기 전이거나 일부 키가 누락된 경우 undefined가 산술에 끼어들어
    // NaN이 state로 전파되고 JSX에 렌더되어 "Received NaN for the children attribute" 경고가 떴다.
    // 모든 산술 입력에 `|| 0` fallback을 적용해 NaN 전파를 차단한다.
    setCountInfo({
      ...countInfo,
      issuInbox: props.countInfo?.ALL || 0,
      countInbox: (props.countInfo?.ALL || 0) - (props.countInfo?.['03'] || 0),
      sentInbox: props.sentInfo?.ALL || 0,
      tempCount: (props.sentInfo?.TEMP || 0) + (props.countInfo?.TEMP || 0),
      chempCertboxCount: props.chempCertboxCount?.ALL || 0,
      chempSendboxCount: props.chempSendboxCount?.ALL || 0,
    })
  }, [props.countInfo])
  // 기존 앱쪽에서 준 소스
  // const handleDeviceId = (params) => {
  //    props.setDeviceId(JSON.parse(params.data).deviceId);
  // }

  const handleDeviceId = (params) => {
    // 개발서버 apk 에서 테스트 진행 해봐야됨
    console.log(' = = = params = = = = ' + params?.data)

    try {
      if (params?.data) {
        const { deviceId } = JSON.parse(params.data)
        if (deviceId) {
          props.setDeviceId(deviceId)
        }
      }
    } catch (e) {}
  }
  /**
   * 디바이스 ID 받아오는 부분 처리 끝
   */

  const openUth = () => {
    if (commons.isMobile()) {
      history.push('/openLink')
    }
  }

  const goLink = (url) => {
    history.push(url)
  }

  const ewalletIdCopy = () => {
    if (!auth?.isLoggedIn) {
      //return props.error({ title: '확인', message: '로그인 시 이용 가능합니다.' })
      window.location.href = '/loginintro'
    }
    $('#myWallet > button').trigger('click')
  }

  // 앱이면 네이티브 스캔, 모바일 웹(브리지 없음)이면 웹 카메라 실시간 스캔
  const [qrWebOpen, setQrWebOpen] = useState(false)

  function qrReport() {
    try {
      qrScanNative()
    } catch (e) {
      setQrWebOpen(true)
    }
  }

  function onQrWebResult(text) {
    setQrWebOpen(false)
    const data = new FormData()
    data.append('readData', text)
    const xhr = new XMLHttpRequest()
    xhr.responseType = 'blob'
    xhr.open('POST', process.env.REACT_APP_API_URL + '/portal/file/qr/qrScan')
    xhr.onload = function () {
      if (xhr.status === 200) {
        const viewUrl = process.env.REACT_APP_API_URL + '/pdfViewer/pdfViewer.html?file=' + window.URL.createObjectURL(xhr.response)
        if (!window.open(viewUrl, '_blank')) window.location.href = viewUrl
      } else if (xhr.status === 406) {
        props.error({ title: '확인', message: '회수된 문서입니다.' })
      } else {
        props.error({ title: '확인', message: '잘못된 QR코드 입니다.' })
      }
    }
    xhr.onerror = () => props.error({ title: '확인', message: 'QR 조회 중 오류가 발생했습니다.' })
    xhr.send(data)
  }

  function onQrWebError(message) {
    setQrWebOpen(false)
    props.error({ title: '확인', message })
  }

  function qrScanNative() {
    window.M.plugin('qr').scan({
      flash: false,
      fadeToggle: true,
      orientation: 'PORTRAIT',
      page: 'CustomQRActivity',
      filterType: 'QRCODE',
      onscan: function (result) {
        if (result.status === 'NS') {
          console.log('This QRCode Plugin is not supported')
        } else if (result.status === 'CANCEL') {
          console.log('Scanning is canceled')
        } else if (result.status !== 'SUCCESS') {
          if (result.message) {
            console.log(result.status + '1 :' + result.message)
          } else {
            console.log('This QRCode Plugin is failed')
          }
        } else {
          if (result.text) {
            console.log(JSON.stringify(result) + ' : ' + result.status + '2 :' + result.text)
            let data = new FormData()
            data.append('readData', result.text)
            let url = process.env.REACT_APP_API_URL + '/portal/file/qr/qrScan'
            let xhr = new XMLHttpRequest()
            xhr.responseType = 'blob'
            xhr.open('POST', url)
            xhr.send(data)
            xhr.onload = function () {
              console.log(JSON.stringify(result) + ' : ' + result.status + '3 :' + result.text)
              console.log('test : ' + JSON.stringify(xhr.status) + ', ' + xhr.response)
              if(xhr.status === 200){
                window.M.execute(
                  'exWNStartViewPDFActivity',
                  process.env.REACT_APP_API_URL + '/pdfViewer/pdfViewer.html?file=' + window.URL.createObjectURL(xhr.response),
                )
              }else if(xhr.status == 406){
                window.M.pop.alert('회수된 문서입니다.')
              }else{
                window.M.pop.alert('잘못된 QR코드 입니다.')
              }
              
              //window.open('/pdfViewer/pdfViewer.html?file=' + window.URL.createObjectURL(xhr.response), '_blank');
            }
          } else {
            window.M.pop.alert('QRCode data is not scanning')
          }
        }
      },
    })
    //document.querySelector('.qr').click()
  }

  useEffect(() => {
    if (auth?.isLoggedIn) {
      setUserInfo(auth?.user?.payload)
      // modDt 오늘날짜로부터 3개월확인
      //if (true) {
      if (props.isRequirePassChange) {
        props.confirm({
          title: '비밀번호 변경 알림',
          message: '3개월마다 새로운 비밀번호로 변경해야 합니다. \n 변경 후 사용해 주시기 바랍니다.',
          params: {
            okBtnTitle: '지금변경하기',
            cancelBtnTitle: '나중에변경하기',
            type: 'confirm',
            cancelCallback: () => {
              // PASSWD_MOD_DT 수정
              // props.passwdModDt(userInfo)

              // password 암호화 방식 변경에 따른 구분자 설정 작업
              let sendObj = {
                userId: userInfo.memberId,
                passwd: '-',
                newPassword: '-',
                newPasswordConfirm: '-',
              }
              props.updatePass(sendObj)

              props.success({
                title: '성공',
                message: '완료되었습니다.',
                params: {
                  type: 'SUCCESS',
                  callback: () => {
                    //props.getGroupInfo();
                    window.location.reload()
                  },
                },
              })
            },
            callback: () => {
              history.push('/change/pass')
            },
          },
        })
      }
    }
  }, [props.isRequirePassChange])
  return (
    <div id="contents" className="main">
      {/* <Alert /> */}
      <div className="main-sec01">
        {/* 로그인후 */}

        { auth?.isLoggedIn &&
            ['kcl','ktc','ktr','katri','kotiti','fiti','keiti','chemp'].includes(auth?.user?.payload?.memberId) ? (
            <>
              <NoticePopup01 />
              <div className="state-cont">
                <ul>
                  <li>
                    <a href="/service/certbox">
                      <dl>
                        <dt>내문서</dt>
                        <dd>
                          {/* 두 값 중 하나라도 undefined면 undefined + undefined = NaN이 렌더링되어
                              "Received NaN for the children attribute" 경고가 떴다. 안전 합산으로 변경. */}
                          <span>{(countInfo.chempCertboxCount || 0) + (countInfo.chempSendboxCount || 0)}</span> 건
                        </dd>
                      </dl>
                    </a>
                  </li>
                  <li>
                    <a href="/service/certbox/chemp">
                      <dl>
                        <dt>받은문서</dt>
                        <dd>
                          <span>{countInfo.chempCertboxCount}</span> 건
                        </dd>
                      </dl>
                    </a>
                  </li>
                  <li>
                    <a href="/service/certbox/chemp/sendbox">
                      <dl>
                        <dt>보낸문서</dt>
                        <dd>
                          <span>{countInfo.chempSendboxCount}</span> 건
                        </dd>
                      </dl>
                    </a>
                  </li>
                </ul>
              </div></>
        ) : auth?.isLoggedIn ? (
            <>
              <NoticePopup01 />
              <div className="state-cont">
                <ul>
                  <li>
                    <a href="/service/certbox">
                      <dl>
                        <dt>내문서</dt>
                        <dd>
                          <span>{countInfo.issuInbox}</span> 건
                        </dd>
                      </dl>
                    </a>
                  </li>
                  <li>
                    <a href="/service/certbox?tabStatus=98">
                      <dl>
                        <dt>받은문서</dt>
                        <dd>
                          <span>{countInfo.countInbox}</span> 건
                        </dd>
                      </dl>
                    </a>
                  </li>
                  <li>
                    <a href="/service/sent">
                      <dl>
                        <dt>보낸문서</dt>
                        <dd>
                          <span>{countInfo.sentInbox}</span> 건
                        </dd>
                      </dl>
                    </a>
                  </li>
                </ul>
              </div></>
          ) : (
            ''
          )
        }

        {/* //로그인후 */}
        <div className="visual-slider">
          <div className="guide-cont">
            <div className="ctrl-wrap">
              <button type="button" className="btn-prev">
                이전
              </button>
              <span className="pager" />
              <button type="button" className="btn-next">
                다음
              </button>
              <button type="button" className="btn-pause">
                정지
              </button>
              <button type="button" className="btn-play">
                재생
              </button>
            </div>
            <ul className="cont-list">
              {/* <li className="pc-only">
                <Link title="증명서 신청" to="/service/certmng">
                  증명서 신청
                </Link>
              </li> */}
              <li className="pc-only">
                <Link title="신청내역" to="/service/certissue">
                  신청내역
                </Link>
              </li>
              <li className="pc-only">
                {!auth?.isLoggedIn ? (<Link title="진본검증" to="/service/verify/nm">진본검증</Link>):(<Link title="진본검증" to="/service/verify">진본검증</Link>)}
              </li>
              <li className="mobile-only">
                <a title="지갑주소" onClick={ewalletIdCopy}>
                  지갑주소
                </a>
              </li>
              <li className="mobile-only">
                <Link title="진본확인" to="/service/verify">
                  진본확인
                </Link>
              </li>
              <li className="mobile-only">
                <a title="위변조확인" onClick={qrReport}>
                  위변조확인
                  <br />
                  (QR)
                </a>
                {qrWebOpen && (
                  <QrScanModal onResult={onQrWebResult} onError={onQrWebError} onClose={() => setQrWebOpen(false)} />
                )}
              </li>
            </ul>
          </div>
          <button type="button" className="btn-prev side">
            이전
          </button>
          <button type="button" className="btn-next side">
            다음
          </button>
          <ul className="owl-carousel owl-visual">
            <li className="item1">
              <dl className="guide-text">
                <dt>디지털 무역 · 물류문서 유통센터</dt>
                <dd className="dd01">
                  <span>디지털전자무역이</span> 함께합니다.
                </dd>
                <dd>
                  <span>무역, 물류 업무과정에서 유통되는</span> 비표준 비정형 증명문서,
                  <br /> 이제 전자문서지갑으로 처리할 수 있습니다.
                </dd>
                <dd>
                  <a href="/guide" className="btn-use">
                    이용안내 바로가기
                  </a>
                </dd>
              </dl>
            </li>
            <li className="item2">
              <dl className="guide-text">
                <dt>디지털 무역 · 물류문서 유통센터</dt>
                <dd className="dd01">
                  <span>디지털전자무역이</span> 함께합니다.
                </dd>
                <dd>
                  <span>무역, 물류 업무과정에서 유통되는</span> 비표준 비정형 증명문서,
                  <br /> 이제 전자문서지갑으로 처리할 수 있습니다.
                </dd>
                <dd>
                  <a href="/guide" className="btn-use">
                    이용안내 바로가기
                  </a>
                </dd>
              </dl>
            </li>
          </ul>
        </div>
      </div>
      <div className="main-sec02">
        <h2>원스톱 서비스 제공</h2>
        <div className="service-slider">
          <div className="ctrl-wrap">
            <span className="pager" />
            <button type="button" className="btn-prev">
              이전
            </button>
            <button type="button" className="btn-next">
              다음
            </button>
          </div>
          <ul className="owl-carousel owl-service">
            <li>
              <div className="thumb">
                <img src={onestop_img1} alt="" />
              </div>
              <dl>
                <dt>실시간 전자증명서 즉시 발급</dt>
                <dd>
                  <span>오프라인 발급과 제출, 불편하셨죠?</span> 이제 실시간으로 발급된 전자증명서를 즉시 제출할 수 있습니다.
                  <br /> 증명서 발급, 제출에 소요되는 시간과 비용을 절감합니다.
                </dd>
                <dd>
                  {/* <a href="#" className="btn-detail">
                    자세히보기
                  </a> */}
                </dd>
              </dl>
            </li>
            <li>
              <div className="thumb">
                <img src={onestop_img2} alt="온라인으로 위변조 여부 확인" />
              </div>
              <dl>
                <dt>온라인으로 위변조 여부 확인</dt>
                <dd>
                  <span>오프라인 수취와 진위확인 불편하셨죠?</span> 전자증명서 수취 즉시 타임스탬프 및 블록체인 기술로
                  <br /> 온라인에서도 위변조 여부를 확인할 수 있습니다.
                </dd>
                <dd>
                  {/* <a href="#" className="btn-detail">
                    자세히보기
                  </a> */}
                </dd>
              </dl>
            </li>
            <li>
              <div className="thumb">
                <img src={onestop_img3} alt="발급 증명서 위변조 위험 방지" />
              </div>
              <dl>
                <dt>발급 증명서 위변조 위험 방지</dt>
                <dd>
                  <span>증명서의 기술적 위변조 방지 조치 제공!</span> 전자무역, 시험성적서, 교정성적서 등 기업 비즈니스에
                  <br /> 발급/유통되는 증명서는 계속 확장됩니다.
                </dd>
                <dd>
                  {/* <a href="#" className="btn-detail">
                    자세히보기
                  </a> */}
                </dd>
              </dl>
            </li>
          </ul>
        </div>
      </div>
      <div className="main-sec03">
        <div className="inner">
          <h2>공지사항</h2>
          <div className="notice-slider">
            <ul className="owl-carousel owl-notice">
              <li>
                {props.data?.content[0] !== undefined && (
                  <Link title="공지사항1" to={'/notice/' + props.data?.content[0]?.noticeSeq}>
                    <p className="tit">{props.data?.content[0].noticeSj}</p>
                    <p className="date">{moment(props.data?.content[0]?.regDt).format('YYYY.MM.DD')}</p>
                  </Link>
                )}
              </li>
              <li>
                {props.data?.content[1] !== undefined && (
                  <Link title="공지사항2" to={'/notice/' + props.data?.content[1]?.noticeSeq}>
                    <p className="tit">{props.data?.content[1]?.noticeSj}</p>
                    <p className="date">{moment(props.data?.content[1]?.regDt).format('YYYY.MM.DD')}</p>
                  </Link>
                )}
              </li>
              <li>
                {props.data?.content[2] !== undefined && (
                  <Link title="공지사항3" to={'/notice/' + props.data?.content[2]?.noticeSeq}>
                    <p className="tit">{props.data?.content[2]?.noticeSj}</p>
                    <p className="date">{moment(props.data?.content[2]?.regDt).format('YYYY.MM.DD')}</p>
                  </Link>
                )}
              </li>
              <li>
                {props.data?.content[3] !== undefined && (
                  <Link title="공지사항4" to={'/notice/' + props.data?.content[3]?.noticeSeq}>
                    <p className="tit">{props.data?.content[3]?.noticeSj}</p>
                    <p className="date">{moment(props.data?.content[3]?.regDt).format('YYYY.MM.DD')}</p>
                  </Link>
                )}
              </li>
              <li>
                {props.data?.content[4] !== undefined && (
                  <Link title="공지사항5" to={'/notice/' + props.data?.content[4]?.noticeSeq}>
                    <p className="tit">{props.data?.content[4]?.noticeSj}</p>
                    <p className="date">{moment(props.data?.content[4]?.regDt).format('YYYY.MM.DD')}</p>
                  </Link>
                )}
              </li>
              {/* 
                {props.data?.content?.map((notice, idx) =>
                  idx !== 0 && idx < 5 ? (
                    <li key={notice.noticeSeq}>
                      <Link title="공지사항" to={'/notice/' + notice.noticeSeq}>
                        <p className="tit">{notice.noticeSj}</p>
                        <p className="date">{moment(notice?.regDt).format('YYYY.MM.DD')}</p>
                      </Link>
                    </li>
                  ) : (
                    ''
                  ),
                )} 
              */}
            </ul>
          </div>
          <ul className="link-service">
            <li>
              <Link title="FAQ" to="/faq">
                <i className="ico" />
                <dl>
                  <dt>FAQ</dt>
                  <dd>바로가기</dd>
                </dl>
              </Link>
            </li>
            <li>
              <Link title="이용안내" to="/guide">
                <i className="ico" />
                <dl>
                  <dt>이용안내</dt>
                  <dd>바로가기</dd>
                </dl>
              </Link>
            </li>
            <li>
              <Link title="자료실" to="/reference">
                <i className="ico" />
                <dl>
                  <dt>자료실</dt>
                  <dd>바로가기</dd>
                </dl>
              </Link>
            </li>
          </ul>
          {/* <ul className="link-request">
            <li>
              <Link title="구매확인서 신청하기" to="/service/certmng">
                <i className="ico" />
                <p>구매확인서 신청하기</p>
              </Link>
            </li>
            <li>
              <Link title="사업자등록증명 신청하기" to="/service/certmng">
                <i className="ico" />
                <p>사업자등록증명 신청하기</p>
              </Link>
            </li>
            <li>
              <Link title="운전자경력증명 신청하기" to="/service/certmng">
                <i className="ico" />
                <p>운전자경력증명 신청하기</p>
              </Link>
            </li>
          </ul> */}
        </div>
      </div>
      <div className="main-sec04 pc-only">
        <div className="inner">
          <div className="banner-slider">
            <ul className="owl-carousel owl-banner">
              <li>
                <a href="http://www.motie.go.kr/www/main.do" target="_blank" rel='noopnner noreferrer'>
                  <img src={require('../../assets/images/main/main_banner1.png')} alt="산업통상자원부" />
                </a>
              </li>
              <li>
                <a href="https://www.kita.net/" target="_blank" rel='noopnner noreferrer'>
                  <img src={require('../../assets/images/main/main_banner2.png')} alt="KITA" />
                </a>
              </li>
              <li>
                <a href="https://www.ksure.or.kr/index.do" target="_blank" rel='noopnner noreferrer'>
                  <img src={require('../../assets/images/main/main_banner3.png')} alt="한국무역보험공사" />
                </a>
              </li>
              <li>
                <a href="https://www.kodit.co.kr/index.jsp" target="_blank" rel='noopnner noreferrer'>
                  <img src={require('../../assets/images/main/main_banner4.png')} alt="신용보증기금" />
                </a>
              </li>
              <li>
                <a href="https://www.sw.or.kr/site/sw/main.do" target="_blank" rel='noopnner noreferrer'>
                  <img src={require('../../assets/images/main/main_banner5.png')} alt="KOSA" />
                </a>
              </li>
              <li>
                <a href="https://www.at.or.kr/home/acko000000/index.action" target="_blank" rel='noopnner noreferrer'>
                  <img src={require('../../assets/images/main/main_banner6.png')} alt="AT센터" />
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  )
}
const mapStateToProps = (state) => {
  return {
    data: state.notice?.data,
    auth: state.auth,
    isRequirePassChange: state.userinfo?.isRequirePassChange,
    countInfo: state.certbox?.certboxList?.count,
    sentInfo: state.sent?.SentList?.count,
    chempCertboxCount: state.chempCertbox?.certboxList?.count,
    chempSendboxCount: state.chempSendbox?.sendboxList?.count,
    appAccessResult: state.setting.appAccessResult,
  }
}
const actionCreators = {
  notiLoad: noticeActions.load,
  // memberAppInsert: memberAppActions.insert,
  insertDeviceId: memberAppActions.insertDeviceId,
  load: userinfoActions.load,
  logOut: authActions.logOut,
  confirm: alertActions.confirm,
  updatePass: userinfoActions.updatePass,
  // passwdModDt: userinfoActions.passwdModDt,
  success: alertActions.success,
  error: alertActions.error,
  setDeviceId: userinfoActions.setDeviceId,
  getGroupInfo: manageActions.getGroupInfo,
  readInboxList: certboxActions.readcertboxList,
  readSentList: sentActions.readSentList,
  verifiPdf: manageActions.verifiPdf,
  readCertboxList: chempCertboxActions.readCertboxList,
  readSendboxList: chempSendboxActions.readSendboxList,
}
export default connect(mapStateToProps, actionCreators)(Index)
